import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/AdaptiveCardRenderer.module_built.css";
const classes = {"adaptive-card-renderer":"wyhD4jG_adaptive-card-renderer","adaptive-card-renderer__action--selected":"wyhD4jG_adaptive-card-renderer__action--selected"}
export default classes

const _adaptive_card_renderer0 = classes["adaptive-card-renderer"]
export { _adaptive_card_renderer0 as "adaptive-card-renderer" }

const _adaptive_card_renderer__action__selected0 = classes["adaptive-card-renderer__action--selected"]
export { _adaptive_card_renderer__action__selected0 as "adaptive-card-renderer__action--selected" }
